import React, { useState } from 'react';
import { FaPills, FaHospital, FaCalendarAlt } from 'react-icons/fa';
import { MdPendingActions } from 'react-icons/md';
import { toast } from 'react-toastify';
import api from '../../../utils/api';
import { api_url } from '../../../config';
import { useSelector } from 'react-redux';

const PendingComponent = ({ order, fetchOrder }) => {
    const { id, branch_id, token } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);

    const handleCancelOrder = async () => {
        if (!order?.id) {
            toast.error("No order selected");
            return;
        }

        setLoading(true);
        try {
            await api.put(
                `${api_url}/api/v1/retailer/user/${id}/branch/${branch_id}/order/${order.id}/cancel`,
                {},
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            toast.success("Order cancelled successfully");
            fetchOrder(); // Refresh the order data
        } catch (error) {
            console.error(error);
            toast.error(error.response?.data?.message || "Failed to cancel order");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-4 sm:p-6">
            {/* Header Section */}
            <div className="mb-6">
                <div className="flex items-center gap-3 mb-2">
                    <MdPendingActions className="text-green-500 text-2xl" />
                    <h2 className="text-xl font-semibold text-gray-800">Pending Orders</h2>
                </div>
                <p className="text-sm text-gray-600">Track your pending orders with suppliers</p>
            </div>

            {/* Orders Table */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-100">
                        <thead>
                            <tr className="bg-gray-50">
                                <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">
                                    <div className="flex items-center gap-2">
                                        <FaPills className="text-green-500" />
                                        <span>Product Details</span>
                                    </div>
                                </th>
                                <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">
                                    <div className="flex items-center gap-2">
                                        <FaHospital className="text-green-500" />
                                        <span>Supplier</span>
                                    </div>
                                </th>
                                <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">
                                    <div className="flex items-center gap-2">
                                        <FaCalendarAlt className="text-green-500" />
                                        <span>Expiry Date</span>
                                    </div>
                                </th>
                                <th className="px-6 py-4 text-right text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">Quantity</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                            {order?.items?.map((item) => (
                                <tr key={item.id} className="hover:bg-gray-50 transition-colors duration-200">
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="flex items-center gap-3">
                                            <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center">
                                                <FaPills className="text-green-500 text-sm" />
                                            </div>
                                            <div>
                                                <p className="text-sm font-medium text-gray-900">{item.product?.name}</p>
                                                <p className="text-xs text-gray-500">ID: {item.product?.id}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="flex items-center gap-2">
                                            <span className="text-sm text-gray-600">{item.product?.supplier?.name}</span>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <span className="text-sm text-gray-600">{item.product?.expiry_date}</span>
                                    </td>
                                    <td className="px-6 py-4 text-right whitespace-nowrap">
                                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                            {item.quantity} units
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Action Buttons */}
            <div className="mt-6 flex flex-col sm:flex-row justify-end gap-3">
                <button 
                    onClick={handleCancelOrder}
                    disabled={loading}
                    className="w-full sm:w-auto px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    {loading ? 'Processing...' : 'Cancel Order'}
                </button>
            </div>
        </div>
    );
}

export default PendingComponent;
